import React, { useState, useEffect } from "react";
import { useDebouncedValue } from "../../../../../../hooks/useDebouncedValue";
import ClearButton from "../../../../../../components/ClearButton/ClearButton";
import { Button } from "@/components/ui/button";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";

interface CustomerListFiltersProps {
  filters: { searchTerm?: string; isActive: number };
  onFilterChange: (searchTerm: string, isActive: number) => void;
  onExportCsv: () => void;
  isExporting: boolean;
}

const CustomerListFilters: React.FC<CustomerListFiltersProps> = ({
  filters,
  onFilterChange,
  onExportCsv,
  isExporting,
}) => {
  const [nameFilter, setNameFilter] = useState(filters.searchTerm || "");
  const [isActive, setIsActive] = useState(filters.isActive);
  const debouncedNameFilter = useDebouncedValue(nameFilter, 500);

  useEffect(() => {
    onFilterChange(debouncedNameFilter, isActive);
  }, [debouncedNameFilter, isActive]);

  const onFilterInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNameFilter(e.target.value);
  };

  const onClearFilter = () => {
    setNameFilter("");
    onFilterChange("", isActive);
  };

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between space-x-2">
        <div className="flex items-center space-x-2">
          <div className="relative w-full max-w-md">
            <input
              className="px-3 py-2 pr-10 w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-secondary focus:border-secondary dark:bg-slate-800 dark:border-slate-700 dark:text-slate-100 dark:focus:ring-primary dark:focus:border-primary"
              onChange={onFilterInputChange}
              placeholder="Search by name"
              type="text"
              value={nameFilter}
            />
            <ClearButton isVisible={!!nameFilter} onClick={onClearFilter} />
          </div>

          <select
            className="border rounded-md px-2 py-2 bg-white dark:bg-slate-800 dark:border-slate-700 dark:text-slate-100"
            onChange={(e) => setIsActive(parseInt(e.target.value, 10))}
            value={isActive}
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </select>
        </div>

        <Button
          className="bg-green-600 hover:bg-green-700"
          disabled={isExporting}
          onClick={onExportCsv}
        >
          <ArrowDownTrayIcon className="h-4 w-4 mr-2" />
          {isExporting ? "Exporting..." : "Export CSV"}
        </Button>
      </div>
    </div>
  );
};

export default CustomerListFilters;
